// MUTATIONS
export const SET_SNACKBAR_SUCCESS = 'snackbar/SET_SNACKBAR_SUCCESS'
export const SET_SNACKBAR_ERROR = 'snackbar/SET_SNACKBAR_ERROR'
export const SET_SNACKBAR_WARNING = 'snackbar/SET_SNACKBAR_WARNING'
export const SET_SNACKBAR = 'snackbar/SET_SNACKBAR'
export const SET_SNACKBAR_TO_HIDE = 'snackbar/SET_SNACKBAR_TO_HIDE'

// ACTIONS
export const NOTIFY_SUCCESS = 'snackbar/NOTIFY_SUCCESS'
export const NOTIFY_ERROR = 'snackbar/NOTIFY_ERROR'
export const NOTIFY_WARNING = 'snackbar/NOTIFY_WARNING'
export const NOTIFY = 'snackbar/NOTIFY'
export const HIDE_SNACKBAR = 'snackbar/HIDE_SNACKBAR'
